export function resolveSiteAssetUrl(value:unknown){if(typeof value!=='string')return'';if(value.startsWith('/')&&!value.startsWith('//'))return value;try{const u=new URL(value);return u.protocol==='https:'?u.href:'';}catch{return'';}}
